
    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'
    import appconst from '@/lib/appconst';
    import Enums from '@/lib/enums'
    import storeaddressInfo from '@/store/entities/back-storeaddress-list';
    class AddBaseCost {
        userCode: string;
        costPoints: number;
        orderType: number;
        isEnable: boolean;
        storeId?: number;
    }
    @Component
    export default class CreateUserStorageConfigModule extends AbpBase {
        @Prop({ type: Boolean, default: false }) value: boolean;
        freight: AddBaseCost = new AddBaseCost();
        addLoding = false;
        amountTotal: string = '';
        isShow: boolean = false;
        storeaddressList: Array<storeaddressInfo> = [];
        userConfigOrderType = Enums.getEnum(Enums.UserConfigOrderType, false);
        created() {
        }
        signFor() {
            this.save();
        }
        save() {
            (this.$refs.freightCreateForm as any).validate(async (valid: boolean) => {
                if (valid) {
                    if (this.freight.orderType == 0 || this.freight.orderType == 1) {
                        this.freight.storeId = null;
                    }
                    else {
                        if (this.freight.storeId == null) {
                            alert("请选择对应仓库！");
                            return;
                        }
                    }
                    this.addLoding = true;
                    this.freight.isEnable = true;
                    await this.$store.dispatch({
                        type: 'backuserstorageconfigSetting/edit',
                        data: this.freight
                    }).finally(() => {
                        this.addLoding = false;
                    });
                    (this.$refs.freightCreateForm as any).resetFields();
                    this.$emit('save-success');
                    this.$emit('input', false);
                }
            })
        }
        async changeOrderType() {
            if (this.freight.orderType == 0 || this.freight.orderType == 1) {
                this.isShow = false;
            }
            else {
                this.isShow = true;
                if (this.storeaddressList.length == 0) {
                    await this.$store.dispatch({
                        type: 'backstoreaddress/getAll',
                        data: {}
                    })
                    this.storeaddressList = this.$store.state.backstoreaddress.list.filter(function (item) { return item.whetherEffective == true });
                }
            }
        }
        cancel() {
            (this.$refs.freightCreateForm as any).resetFields();
            this.$emit('input', false);
        }
        visibleChange(value: boolean) {
            if (!value) {
                this.$emit('input', value);
            } else {
            }
        }
        freightRule = {
            userCode: [{ required: true, message: "用户编号不能为空", trigger: 'blur' }],
            costPoints: [{ required: true, message: '费用不能为空（按积分计算）', trigger: 'blur' } ],
        };

    }
